
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.81818 21H12.8027C12.2922 20.1175 12 19.0929 12 18C12 14.6863 14.6863 12 18 12C19.5367 12 20.9385 12.5777 22 13.5278V7.6C22 7.04771 21.5523 6.6 21 6.6H11.6293C11.2447 6.6 10.8941 6.37938 10.7278 6.03258L9.54497 3.56742C9.37858 3.22062 9.02803 3 8.64338 3H3C2.44772 3 2 3.44771 2 4V10.8V19.2C2 19.6774 2.19156 20.1352 2.53253 20.4728C2.87351 20.8104 3.33597 21 3.81818 21ZM14 17.4115C14.7581 15.9773 16.2649 15 18 15C19.7351 15 21.2419 15.9773 22 17.4115C21.2419 18.8456 19.7351 19.8229 18 19.8229C16.2649 19.8229 14.7581 18.8456 14 17.4115ZM19.2059 17.4115C19.2059 18.0774 18.6661 18.6172 18.0002 18.6172C17.3343 18.6172 16.7945 18.0774 16.7945 17.4115C16.7945 16.7456 17.3343 16.2057 18.0002 16.2057C18.6661 16.2057 19.2059 16.7456 19.2059 17.4115Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowAttachmentPreviewFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
